import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AssetService } from 'src/app/services/asset.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-hand-held-plant-inspection-checklist',
  templateUrl: './hand-held-plant-inspection-checklist.component.html',
  styleUrls: ['./hand-held-plant-inspection-checklist.component.scss']
})
export class HandHeldPlantInspectionChecklistComponent implements OnInit {

  hand_held_plant_inspection_checklist_form: FormGroup
  sign: Boolean = false
  isSubmit: boolean;
  assetId
  userId: any;
  loading
  handHeldFormData = []
  selectedIndex
  selectedFormDetails
  isEdit: Boolean
  files: any = [];
  newFiles: any = [];
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  previousIndex: any;
  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  currentUser: any;
  _isControlDisable = false

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public activatedRouter: ActivatedRoute,
    public _assetService: AssetService,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
  ) { }

  techCandidateSign

  ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
    })
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log("this.currentUser", this.currentUser);
    this.createForm();
    this.isSubmit = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Hand-held changes", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue) {

      let data = changes.documentDetails.currentValue
      console.log("data--->", data);
      let allFormList = data.filter((x) => x.userDocumentId.documentMetaId.title === 'hand_held_plant_inspection_checklist_form')
      console.log("same for data for multiple forms", allFormList);

      if (allFormList && allFormList.length) {
        this.handHeldFormData = allFormList
        this.selectedIndex = this.handHeldFormData[0]._id
        this.selectedFormDetails = this.handHeldFormData[0].userDocumentId
        this._isControlDisable = true

        // this.createForm(this.handHeldFormData[0].userDocumentId.details.inspectionForm)
        this.changeFormData()
      }
    }
  }

  // CREATE-FORM

  createForm(data?) {
    console.log("data", data);
    this.hand_held_plant_inspection_checklist_form = new FormGroup({
      name: new FormControl((data && data.name) ? data.name : ''),
      inspectionDate: new FormControl((data && data.inspectionDate) ? data.inspectionDate : moment(new Date()).format("MM/DD/YYYY")),
      // inspectionDate: new FormControl((data && data.inspectionDate) ? data.inspectionDate : ''),
      calibrationDate: new FormControl((data && data.calibrationDate) ? data.calibrationDate : ''),
      comment1: new FormControl((data && data.comment1) ? data.comment1 : ''),
      answer1: new FormControl((data && data.answer1) ? data.answer1 : ''),
      explain1: new FormControl((data && data.explain1) ? data.explain1 : ''),
      condition: new FormControl((data && data.condition) ? data.condition : ''),
      comment2: new FormControl((data && data.comment2) ? data.comment2 : ''),
      answer2: new FormControl((data && data.answer2) ? data.answer2 : ''),
      explain2: new FormControl((data && data.explain2) ? data.explain2 : ''),
      answer3: new FormControl((data && data.answer3) ? data.answer3 : ''),
      comment3: new FormControl((data && data.comment3) ? data.comment3 : ''),
      answer4: new FormControl((data && data.answer4) ? data.answer4 : ''),
      comment4: new FormControl((data && data.comment4) ? data.comment4 : ''),
      answer5: new FormControl((data && data.answer5) ? data.answer5 : ''),
      comment5: new FormControl((data && data.comment5) ? data.comment5 : ''),
      answer6: new FormControl((data && data.answer6) ? data.answer6 : ''),
      comment6: new FormControl((data && data.comment6) ? data.comment6 : ''),
      answer7: new FormControl((data && data.answer7) ? data.answer7 : ''),
      comment7: new FormControl((data && data.comment7) ? data.comment7 : ''),
      actionComment: new FormControl((data && data.actionComment) ? data.actionComment : ''),
      completedDate: new FormControl((data && data.completedDate) ? data.completedDate : ''),
      inspectionBy: new FormControl((data && data.inspectionBy) ? data.inspectionBy : ''),
      sign: new FormControl((data && data.sign) ? data.sign : '')
    })

    if (this._isControlDisable) {
      this.hand_held_plant_inspection_checklist_form.disable()
    }
  }


  // UTILITY

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formControl == 'completedDate') {
      this.hand_held_plant_inspection_checklist_form.patchValue({ completedDate: value })
    }
    else if (formControl == 'calibrationDate') {
      this.hand_held_plant_inspection_checklist_form.patchValue({ calibrationDate: value })
    }
    else {
      this.hand_held_plant_inspection_checklist_form.patchValue({ inspectionDate: value })
    }
  }

  changeEvent(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("handHeldFormData", this.handHeldFormData);
    console.log("index", index);
    this.selectedIndex = this.handHeldFormData[index]._id
    this.selectedFormDetails = this.handHeldFormData[index].userDocumentId
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
    } else {
      this._isControlDisable = false
    }
    this.changeFormData()
  }

  addSignature(fomrControl) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        console.log("data of sign", data);
        this.sign = true
        this.isSubmit = false
        if (fomrControl == 'sign') {
          this.hand_held_plant_inspection_checklist_form.patchValue({
            sign: data
          })
          console.log("sign value", this.hand_held_plant_inspection_checklist_form.value);
        }
      })
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })

      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }

  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }

  changeFormData() {
    this.isEdit = true
    console.log("this.selectedFormDetails.details.hand_held_plant_inspection_checklist_form", this.selectedFormDetails.details.hand_held_plant_inspection_checklist_form.sign);
    if (this.selectedFormDetails.details.hand_held_plant_inspection_checklist_form.sign) {
      this.sign = true
    }
    else {
      this.sign = false
    }
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.createForm(this.selectedFormDetails.details.hand_held_plant_inspection_checklist_form)
  }

  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details['hand_held_plant_inspection_checklist_form'] = {}
    obj.userDocumentId['details'] = details
    this.handHeldFormData.push(obj)
    this.selectedIndex = this.handHeldFormData[this.handHeldFormData.length - 1]._id
    this.selectedFormDetails = this.handHeldFormData[this.handHeldFormData.length - 1].userDocumentId
    this._isControlDisable = false
    // this.handHeldFormData = []
    this.createForm({})
    this.isEdit = false
    this.sign = false
    this.files = []
  }


  // API CALL

  onSubmit() {
    console.log("this.hand_held_plant_inspection_checklist_form", this.hand_held_plant_inspection_checklist_form.value);
    this.loading = true
    if (this.hand_held_plant_inspection_checklist_form.valid) {
      if (this.isEdit) {
        let obj = {
          metaObj: {
            title: 'hand_held_plant_inspection_checklist_form',
          },
          documentId: this.selectedFormDetails.documentId,
          userId: this.userId,
          onModel: 'asset',
          documentMetaId: this.selectedFormDetails.documentMetaId,
          userDocumentId: this.selectedFormDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }
        let details = {
          hand_held_plant_inspection_checklist_form: this.hand_held_plant_inspection_checklist_form.value
        }
        obj['details'] = details
        this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      }
      else {
        let obj = {
          metaObj: {
            title: 'hand_held_plant_inspection_checklist_form',
          },
          documentId: this.assetId,
          userId: this.userId,
          onModel: 'asset',
          files: this.files,
          // documentId: this.planFormDetails._id,
          details: {}
        }
        let details = {
          hand_held_plant_inspection_checklist_form: this.hand_held_plant_inspection_checklist_form.value
        }
        obj['details'] = details
        this._assetService.submitAssetForm(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      }
    }
    else {
      this.isSubmit = true
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this.router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this.router.navigate(['/asset/asset-list/'])
    }
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    // this._sidenavService.setSidenav(event)
    this.openFilesSideNav.emit({ event })
  }


}
